const Theming = {
    textColourLight: "white",
    textColourDark: "black",
    backgroundColourLight: "rgb(237,190,156)",
    backgroundColourDark: "rgb(226,148,91)"
}

export default Theming;